export default "__VITE_ASSET__DriHnX$Y__"